// Remove every locally cached resume draft. Called on sign-out and account
// deletion so the next person to use this browser never inherits the previous
// user's resume content.
export function clearLocalDrafts() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith('resume-autosave'))
      .forEach((k) => localStorage.removeItem(k));
  } catch {
    // localStorage unavailable — nothing to clear
  }
}
